import { render, staticRenderFns } from "./index.vue?vue&type=template&id=555a33ee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=555a33ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/app/components/global/breadcrumbs.vue').default,VRow: require('/app/node_modules/vuetify/lib/components/VGrid/VRow.js').default,VListItem: require('/app/node_modules/vuetify/lib/components/VList/VListItem.js').default,VSelect: require('/app/node_modules/vuetify/lib/components/VSelect/VSelect.js').default,ReviewItem: require('/app/components/dashboard/manager/reviews/review-item.vue').default,CBtn: require('/app/components/ui/button/c-btn.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VListItem,VListItemContent,VListItemTitle,VRow,VSelect})
